import { AfterViewInit, Component, ElementRef, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { MuiButtonBaseClass } from '../button/mui-button-base-class';
import { MuiFabAppearance } from './mui-fab-appearance.type';
import { checkForAccessibleName } from '../../utility';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[mui-fab], a[mui-fab]',
  exportAs: 'muiFab',
  templateUrl: './mui-fab.component.html',
  styleUrls: ['../buttons-shared.scss', './mui-fab.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MuiFab extends MuiButtonBaseClass implements AfterViewInit {
  @HostBinding('class')
  get buttonClassList(): string {
    const classList = ['mui-fab', `mui-fab--${this.appearance}`];

    if (this.small) {
      classList.push('mui-fab--small');
    }

    return classList.join(' ');
  }

  @Input()
  override appearance: MuiFabAppearance = 'primary';

  @Input()
  small = false;

  @Input()
  @HostBinding('attr.aria-label')
  label: string | null = null;

  constructor(protected el: ElementRef) {
    super(el);
  }

  ngAfterViewInit(): void {
    checkForAccessibleName(this.el.nativeElement, 'MuiFab');
  }
}
